import { createTheme, Fade, Grid, makeStyles, TextField } from "@material-ui/core"
import { hooks, Loader, TextButton, Elements } from "@tfo/common"
import { observer } from "mobx-react"
import { useEffect, useState } from "react"
import React, { FormattedMessage, useIntl } from "react-intl"
import { useHistory } from "react-router-dom"
import { regex } from "../../../../utils/regex"
const { Label } = Elements
import { useStore } from '../../../../hooks'
import $http from "../../../../utils/$http"

const defaultTheme = createTheme()

const useStyles = makeStyles({
    link: { fontWeight: 'bold', color: '#0098C3', '&:hover': { cursor: 'pointer', color: '#007A9C' } },
    formContainer: { padding: '2em', maxWidth: '40%', [defaultTheme.breakpoints.down('md')]: { maxWidth: '70%', padding: '0' }, [defaultTheme.breakpoints.down('xs')]: { maxWidth: '100%', padding: '0' } },
    helperText: {
        textAlign: 'right',
        marginRight: 0
    }
})

const MissingInvoiceAddress = observer(() => {
    const rootStore = useStore()
    const { userStore, clientViewStore } = rootStore
    const intl = useIntl()
    const styles = useStyles()
    const history = useHistory()
    const [address, setAddress] = useState({ address: '', postalCode: '', postalArea: '', email: '', companyId: 1 })
    const [disabled, setDisabled] = useState<boolean>(true)
    const [loading, setLoading] = useState<boolean>(false)
    const [responseMessage, setResponseMessage] = useState<string>('')

    useEffect(() => {
        setDisabled(getDisabled())
    }, [address.address, address.postalCode, address.postalArea, address.email])

    const getDisabled = (): boolean => {
        return isInvalid(address.address) || isInvalid(address.postalCode) || isInvalid(address.postalArea) || !regex.email.test(address.email)
    }

    const isInvalid = (value: string): boolean => {
        return value === undefined || value === null || value === ''
    }

    const handleChange = (event: any): void => {
        setAddress({ ...address, [event.target.name]: event.target.value })
    }

    const putCompanyAddress = (): void => {
        setLoading(true)
        setDisabled(true)
        $http.post(`/company/${clientViewStore.company.id}/address`, address).then(() => {
            $http.post(`/invoicing/configuration`).then(() => {
                onSuccess()
            })
                .catch(() => {
                    onFailed()
                })
        })
            .catch(() => {
                onFailed()
            })
    }

    const onSuccess = () => {
        clientViewStore.init().then(() => {
            setResponseMessage('sent')
            setLoading(false)
            setTimeout(() => {
                history.push('/start')
            }, 2000)
        })
    }

    const onFailed = () => {
        setResponseMessage('failed')
        setLoading(false)
        setDisabled(false)
    }

    return (
        <>
            {userStore?.name ?
                <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" style={{ marginTop: '2rem', padding: '1em' }}>
                    <Grid item xs={12}>
                        <h3 style={{ margin: '0' }}>{`${intl.formatMessage({ id: 'common.hello' })} ${userStore.name}`}</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <p style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{intl.formatMessage({ id: 'missing.invoice.address.subtitle' })}</p>
                    </Grid>
                    <Grid container spacing={2} className={styles.formContainer}>
                        <Grid item xs={12}>
                            <TextField required fullWidth multiline minRows={3} label={intl.formatMessage({ id: 'neworder.invoiceaddress' })} name="address" type="text" variant="outlined" defaultValue={address.address} error={isInvalid(address.address)} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField required fullWidth label={intl.formatMessage({ id: 'common.postalcode' })} name="postalCode" type="text" variant="outlined" defaultValue={address.postalCode} error={isInvalid(address.postalCode)} onChange={handleChange} FormHelperTextProps={{ className: styles.helperText }} inputProps={{ maxLength: 12 }} helperText={address.postalCode.length + '/' + '12'} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField required fullWidth label={intl.formatMessage({ id: 'common.postalarea' })} name="postalArea" type="text" variant="outlined" defaultValue={address.postalArea} error={isInvalid(address.postalArea)} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth disabled label={intl.formatMessage({ id: 'common.deliveryMethod' })} type="text" variant="outlined" defaultValue={intl.formatMessage({ id: 'loginpage.email' })} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField required fullWidth label={intl.formatMessage({ id: 'common.email' })} name="email" type="text" variant="outlined" defaultValue={address.email} error={!regex.email.test(address.email)} onChange={handleChange} />
                        </Grid>
                        <Grid container justifyContent="center" style={{ paddingTop: '1em' }}>
                            <TextButton disabled={disabled} loading={loading} onClick={putCompanyAddress}>
                                {intl.formatMessage({ id: 'missing.invoice.address.button' })}
                            </TextButton>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <h3>{intl.formatMessage({ id: 'missing.invoice.address.questions.header' })}</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <FormattedMessage
                            id="missing.invoice.address.questions.content"
                            values={{
                                a: (...chunks) => (
                                    <a className={styles.link}
                                        onClick={() => window.open('mailto:kund@tofindout.se')}>
                                        {chunks}
                                    </a>
                                ),
                            }}
                        />
                    </Grid>
                    {responseMessage !== '' &&
                        <Fade in={responseMessage !== ''} timeout={{ enter: 300, exit: 1000 }}>
                            <Grid item xs={12} style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                <Label style={responseMessage === 'failed' ? { color: 'red' } : {}}>{intl.formatMessage({ id: `response.${responseMessage}` })}</Label>
                            </Grid>
                        </Fade>
                    }
                </Grid>
                :
                <Loader></Loader>
            }
        </>
    )

})

export default MissingInvoiceAddress